import  {createApp} from "vue"
import App from "@/App.vue"
import {store} from "@/store"
import {router} from "@/router.js"
import {addPlugins} from "@/ui/base-ui";
import "@/ui"


const app = createApp(App)
app.use(router)
app.use(store)

addPlugins(app)

app.mount("#app")
